const APICONFIG = {
  clientId: '1_3yx4dg86ylmo0swgokkk0884g4g8cg8c8gs8084wwwc8cc4gkg',
  clientSecret: '1sl6i8zyyt40kcsgw84gsoss8wwo0woc0g44g04w4wcg04owcc',
  url: 'https://crm.vaesken.net',
  //nodeServer:"http://localhost:3031",
  nodeServer: 'https://crm.vaesken.net',
  assetUrl: 'https://crm.vaesken.net',
  helpAdmin: 'https://crm.vaesken.net/docs-admin/static',
  //api: "http://localhost:3031",
  apiKey: "YUZmJDZoO6xE5QpvTLj3RSCAuVGgtfrz",
  help: 'https://crm.vaesken.net/docs/static',
  finderParams : {
    url : 'https://crm.vaesken.net',
    endPointMedia : '/api/media',
    assetUrl : 'https://crm.vaesken.net',
  }
}
module.exports = APICONFIG;


// WEBPACK FOOTER //
// ./src/constants/ApiConfig.js